import * as React from "react";
import * as ReactCSSTransitionReplace from "react-css-transition-replace";
import { isMobile } from "react-device-detect";
import { IText, ITextComponent } from "src/ScrollyInterface";
import { getParamSize, setStyles } from "src/shared/breakpoints";
import { getAlignement, getTextStyle } from "src/shared/getTextStyle";
import "./TextComponent.scss";

const text = (props: ITextComponent) => {
  const {
    breakpoint,
    content,
    mediaLoaded,
    scrollDirection,
    showSideDrawer
  } = props;

  const generateTextStyles = (defaultContent: IText) => {
    const fontSizeNo = defaultContent.font_size
      ? getParamSize(defaultContent.font_size)
      : 16;
    const lineHeightNo = defaultContent.line_height
      ? getParamSize(defaultContent.line_height)
      : 1;
    return {
      fontSize: setStyles(
        {
          default: defaultContent.font_size,
          desktopLg:
            fontSizeNo && fontSizeNo < 20
              ? "30px"
              : defaultContent.font_size && fontSizeNo < 50
              ? "30px"
              : defaultContent.font_size,
          desktopMd: defaultContent.font_size,
          mobileMd:
            fontSizeNo && fontSizeNo > 34 ? "34px" : defaultContent.font_size,
          mobileSm:
            fontSizeNo && fontSizeNo > 32
              ? "32px"
              : defaultContent.font_size && fontSizeNo > 20
              ? "20px"
              : defaultContent.font_size && fontSizeNo > 16
              ? "16px"
              : defaultContent.font_size
        },
        breakpoint
      ),
      lineHeight: setStyles(
        {
          default: defaultContent.line_height,
          desktopLg:
            lineHeightNo && lineHeightNo > 1.3
              ? "1.3em"
              : defaultContent.line_height && lineHeightNo > 1.1
              ? "1.1em"
              : defaultContent.line_height,
          desktopMd: defaultContent.line_height,
          mobileSm:
            lineHeightNo && lineHeightNo > 1.3
              ? "1.3em"
              : defaultContent.line_height && lineHeightNo > 1.1
              ? "1.1em"
              : defaultContent.line_height
        },
        breakpoint
      )
    };
  };

  const generateFrameStyles = () => {
    return {
      backgroundColor: frameBackground,
      display: mediaLoaded ? "block" : "none",
      marginRight:
        content.paragraphs && content.paragraphs[0].align === "right"
          ? setStyles(
              {
                default: "35px",
                tabletSm: "0px"
              },
              breakpoint
            )
          : "0px"
    };
  };

  const renderText = () => {
    return content.paragraphs
      ? content.paragraphs.map((p: IText) => {
          return (
            <div key={p.text} className="Text-box">
              <div
                className="Text"
                style={{ ...getTextStyle(p), ...generateTextStyles(p) }}
              >
                {p.text}
              </div>
            </div>
          );
        })
      : null;
  };

  const frameBackground =
    content.paragraphs && isMobile
      ? content.paragraphs[0].background_mobile
      : content.paragraphs && !isMobile
      ? content.paragraphs[0].background_desktop
      : "";

  const side = scrollDirection === "down" ? "up" : "down";

  return (
    <ReactCSSTransitionReplace
      transitionName={`roll-${side}`}
      transitionEnterTimeout={1000}
      transitionLeaveTimeout={1000}
    >
      <div
        className="Text-content"
        key={`text-${content.id}`}
        style={{
          justifyContent: content.paragraphs
            ? getAlignement(content.paragraphs[0].align)
            : "",
          zIndex: showSideDrawer ? -1 : 1
        }}
      >
        <div className="Text-frame" style={generateFrameStyles()}>
          {mediaLoaded ? renderText() : null}
        </div>
      </div>
    </ReactCSSTransitionReplace>
  );
};

export default text;



// WEBPACK FOOTER //
// ./src/components/TextComponent.tsx